"use client";

import React from "react";

import PageContainer from "@/components/atoms/PageContainer";
import CustomerForm from "@/components/templates/CustomerForm";
import PageLayout from "@/components/templates/PageLayout";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import useGetCustomerById from "@/hooks/requests/customer/use-get-customer-by-id";
import useGetCustomerId from "@/hooks/use-get-customer-id";
import { CustomerMessages } from "@/messages/customer/customer.messages";

type Props = {
  messages: CustomerMessages;
};

function CustomerFormPage({ messages }: Props) {
  const customerId = useGetCustomerId();
  const _id = Number(customerId) || 0;
  const { data: customer, isLoading, error } = useGetCustomerById({ _id });
  const { lang } = useLanguage();

  const BREAD_CRUMBS = [{ title: messages.breadCrumbTitle, href: ROUTE_URLS.customer(lang) }];

  return (
    <PageLayout messages={messages} title={messages.pageTitle} breadCrumbs={BREAD_CRUMBS}>
      <PageContainer>
        <CustomerForm customer={customer} messages={messages} isLoading={isLoading} error={error} />
      </PageContainer>
    </PageLayout>
  );
}

export default CustomerFormPage;
